<script>
  export let disabled = false
  export let checked
  export let value
  export let name
  export let group

  export let size = "20px"
</script>

<input
  disabled={disabled}
  checked={checked}
  value={value}
  bind:group={group}
  type="radio"
  name={name}
  style="--size: {size}"
/>

<style>
  input {
    border-radius: 50%;
    height: var(--size);
    width: var(--size);
    border: #cccccc;
    color: #00468f;
  }
</style>